export default __webpack_public_path__ + "static/media/login_banner_img.c8101488.png";